import React, { Component } from 'react'
import './Welcome.css'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import { Config } from '../../Config'
import 'react-confirm-alert/src/react-confirm-alert.css'
import 'url-search-params-polyfill'
import AuthenticationService from '../Security/AuthenticationService'
import { setUserEmail } from '../../actions/headers'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Training from '../Welcome/Training'
import NavigationServices from '../Common/NavigationServices'
import { displayMaintenanceBanner, hideDisplayMaintenanceBanner } from '../../actions/notifications'

const storeImage = require('../../images/home_store.png')
const userImage = require('../../images/home_user.png')
const accountImage = require('../../images/home_account.png')
const accountImageAdmin = require('../../images/home_accountAdmin.png')
const noticebutton = require('../../images/noticebutton.jpg')
const newclose = require('../../images/newclose.jpg')

class User extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      getBrowserLanguage: languageSettings.getLanguage(),
      bannerMessages: {},
      bannerSubmessages: []
    }
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.navigation = new NavigationServices()
    this.handleNotice = this.handleNotice.bind(this)
  }
  // Handling notice for the close button.
  handleNotice () {
    this.props.hideDisplayMaintenanceBanner()
  }

  componentWillMount () {
    let contextUser = this.authService.getProfile()
    this.setState({ contextUser: contextUser })
    this.checkUndergoMaintenance()
  }
  // Making redux action call to check the welcome banner notice.
  checkUndergoMaintenance () {
    let data = {
      language: this.state.getBrowserLanguage
    }
    this.props.displayMaintenanceBanner(data)
  }
  // welcome Banner.
  renderNotice () {
    let { bannerMessages, DisplayMaintenanceBanner } = this.props.notification
    if (DisplayMaintenanceBanner) {
      return (
        <section className='newFeat_banner'>
          <div>
            <img src={noticebutton} alt='new' className='fleft' />
          </div>
          <div className='noticeContent'>
            <div className='newFeature fleft'>{bannerMessages.UndergoMaintenanceOn}
              {bannerMessages.Submessages.map((message, index) => (
                <ul className='list-notice' key={index}>
                  <li>{message}</li>
                </ul>
              ))}
            </div>
            <div><img src={newclose} alt='new' className='newClose fright' onClick={this.handleNotice} /> </div>
          </div>
        </section>
      )
    } else {
      return ''
    }
  }

  render () {
    let { DisplayMaintenanceBanner } = this.props.notification
    const language = this.state.currentLanguage
    this.state.contextUser = this.authService.getProfile()
    let loggedUser = this.authService.isMasquerade() ? this.authService.getAdminProfile() : this.authService.getProfile()
    const userName = loggedUser.name ? loggedUser.name : loggedUser.User_FirstName
    return (<section className={this.authService.isAdmin() ? '' : 'welcome'}>
      <div className=''>
        <div className={'notice ' + (DisplayMaintenanceBanner ? 'show' : 'hide')}>{this.renderNotice()}</div>
      </div>
      <div className='welcome-page row'>
        <div className='wel_teaser'><span>{t[language].homepageWelcomeMessage}</span>{userName}!</div>
        <div className='welcomeBoxes'>
          <div className='col-lg-4 col-md-4 col-sm-12 col-xs-12 zeroPadding welcomeLogos'>
            <div>
              <div>
                <a href={this.navigation.getUrl('stores')}><img className='homePageImages' src={storeImage} alt='stores' /></a>
              </div>
            </div>
            <div className='sectionDescription'>
              <h4 className='welcomeHeader'><a href={this.navigation.getUrl('stores')}>{t[language].homepageStores}</a></h4>
              <p>{this.authService.isAdmin() ? t[language].homepageStoresDescriptionForAdmin : t[language].homepageStoresDescription}</p>
            </div>
          </div>

          <div className='col-lg-4 col-md-4 col-sm-12 col-xs-12 zeroPadding welcomeLogos'>
            <div>
              <div>
                <a href={this.navigation.getUrl('users')}><img className='homePageImages' src={userImage} alt='users' /></a>
              </div>
            </div>
            <div className='sectionDescription'>
              <h4 className='welcomeHeader'><a href={this.navigation.getUrl('users')}>{t[language].homepageUsers}</a></h4>
              <p>{this.authService.isAdmin() ? t[language].homepageUsersDescriptionForAdmin : t[language].homepageUsersDescription}</p>
            </div>
          </div>
          <div className='col-lg-4 col-md-4 col-sm-12 col-xs-12 zeroPadding welcomeLogos'>
            <div>
              <div>
                <a href={this.navigation.getUrl('accounts')}>{this.renderAdminAccountsImage()}</a>
              </div>
            </div>
            <div className='sectionDescription'>
              <h4 className='welcomeHeader'><a href={this.navigation.getUrl('accounts')}>{this.authService.isAdmin() ? t[language].homepageMyAccount : t[language].homepageMyAccountPublic}</a></h4>
              <p>{this.authService.isAdmin() ? t[language].homepageMyAccountDescriptionForAdmin : t[language].homepageMyAccountDescription}</p>
            </div>
          </div>
        </div>
      </div>
      <div className='trainingSection'> <Training />
      </div>
    </section>)
  }
  renderAdminAccountsImage () {
    if (!this.authService.isAdmin()) {
      return (<img className='homePageImages' src={accountImage} alt='Accounts' />)
    } else {
      return (<img className='homePageImages' src={accountImageAdmin} alt='Admin Accounts' />)
    }
  }
}
function mapStateToProps (state) {
  return {
    headers: state.headers,
    notification: state.notification.notification
  }
}
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      setUserEmail: setUserEmail,
      displayMaintenanceBanner: displayMaintenanceBanner,
      hideDisplayMaintenanceBanner: hideDisplayMaintenanceBanner
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(User)



// WEBPACK FOOTER //
// ./src/components/Welcome/Welcome.js